import { z } from "zod";

export type FeedBackResponse = {
  type: string;
  subject: string;
  message: string;
  email?: string;
  createdAt: string;
};

export const ServerApiErrorSchema = z.object({
  statusCode: z.number(),
  message: z.string(),
  error: z.string(),
});
export type ServerApiError = z.infer<typeof ServerApiErrorSchema>;
